import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.3371 4.88886C10.1173 5.21776 10 5.60444 10 6C10 6.53043 10.2107 7.03914 10.5858 7.41421C10.9609 7.78929 11.4696 8 12 8C12.3956 8 12.7822 7.8827 13.1111 7.66294C13.44 7.44318 13.6964 7.13082 13.8478 6.76537C13.9991 6.39992 14.0387 5.99778 13.9616 5.60982C13.8844 5.22186 13.6939 4.86549 13.4142 4.58579C13.1345 4.30608 12.7781 4.1156 12.3902 4.03843C12.0022 3.96126 11.6001 4.00087 11.2346 4.15224C10.8692 4.30362 10.5568 4.55996 10.3371 4.88886ZM10.8889 10.3371C11.2178 10.1173 11.6044 10 12 10C12.5304 10 13.0391 10.2107 13.4142 10.5858C13.7893 10.9609 14 11.4696 14 12C14 12.3956 13.8827 12.7822 13.6629 13.1111C13.4432 13.44 13.1308 13.6964 12.7654 13.8478C12.3999 13.9991 11.9978 14.0387 11.6098 13.9616C11.2219 13.8844 10.8655 13.6939 10.5858 13.4142C10.3061 13.1345 10.1156 12.7781 10.0384 12.3902C9.96126 12.0022 10.0009 11.6001 10.1522 11.2346C10.3036 10.8692 10.56 10.5568 10.8889 10.3371ZM10.8889 16.3371C11.2178 16.1173 11.6044 16 12 16C12.5304 16 13.0391 16.2107 13.4142 16.5858C13.7893 16.9609 14 17.4696 14 18C14 18.3956 13.8827 18.7822 13.6629 19.1111C13.4432 19.44 13.1308 19.6964 12.7654 19.8478C12.3999 19.9991 11.9978 20.0387 11.6098 19.9616C11.2219 19.8844 10.8655 19.6939 10.5858 19.4142C10.3061 19.1345 10.1156 18.7781 10.0384 18.3902C9.96126 18.0022 10.0009 17.6001 10.1522 17.2346C10.3036 16.8692 10.56 16.5568 10.8889 16.3371Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgMoreVerticalOutline = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgMoreVerticalOutline;
